import { ApiPath } from "enums";
import { Get } from "utils";

export const getTransactionItemsDiscountByStation = async (query) => {
  const res = await Get(`${ApiPath.Transaction}/items/discount`, { ...query });
  return res.data;
};
